export interface RankingItem {
  rank: number;
  title: string;
  category: string;
  heat: string;
  trend: "up" | "down" | "new";
}

export interface FeedItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  time: string;
  comments: string;
  heat: string;
}

export interface PickItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  readTime: string;
  image: string;
}

export interface TopicItem {
  name: string;
  count: string;
}

export interface PostItem {
  id: string;
  user: string;
  initial: string;
  tone: string;
  time: string;
  content: string;
  likes: number;
  replies: string;
  topic: string;
}

export const hotDaily: RankingItem[] = [
  { rank: 1, title: "新剧《长夜微光》首播口碑两极，弹幕区吵到深夜", category: "剧集", heat: "128.6万", trend: "up" },
  { rank: 2, title: "秋季档综艺阵容官宣，老牌搭档回归引回忆杀", category: "综艺", heat: "96.3万", trend: "up" },
  { rank: 3, title: "片场路透流出，主演造型被夸上热搜第一", category: "路透", heat: "88.1万", trend: "new" },
  { rank: 4, title: "音乐节现场返场加唱三首，live 片段全网刷屏", category: "现场", heat: "74.5万", trend: "up" },
  { rank: 5, title: "双十一预热片单公布，冷门佳作扎堆上线", category: "片单", heat: "61.2万", trend: "down" },
  { rank: 6, title: "老剧重制版定档，网友：爷青回还是毁经典", category: "话题", heat: "55.8万", trend: "up" },
  { rank: 7, title: "剧组成立十周年聚会，合照细节被网友逐帧分析", category: "讨论", heat: "49.4万", trend: "new" },
  { rank: 8, title: "剧场版动画预告发布，作画水准引发热议", category: "动画", heat: "43.0万", trend: "down" },
];

export const hotWeekly: RankingItem[] = [
  { rank: 1, title: "年度最具讨论度剧集盘点，前三名毫无悬念", category: "盘点", heat: "412.7万", trend: "up" },
  { rank: 2, title: "综艺名场面合辑走红，网友反复二刷停不下来", category: "综艺", heat: "358.2万", trend: "up" },
  { rank: 3, title: "剧透争议持续发酵，官方连夜发声明回应", category: "话题", heat: "301.5万", trend: "new" },
  { rank: 4, title: "幕后花絮曝光，原来那些名场面都是即兴发挥", category: "花絮", heat: "266.9万", trend: "up" },
  { rank: 5, title: "配音阵容公布，演员原声出演引期待", category: "剧集", heat: "224.3万", trend: "down" },
  { rank: 6, title: "经典 IP 重启计划公布，情怀与争议齐飞", category: "话题", heat: "198.6万", trend: "up" },
  { rank: 7, title: "拍摄地打卡热升温，小众取景地一夜走红", category: "旅行", heat: "167.4万", trend: "new" },
  { rank: 8, title: "年度 OST 榜单出炉，片尾曲被单曲循环", category: "音乐", heat: "142.1万", trend: "down" },
];

export const feedLatest: FeedItem[] = [
  {
    id: "l1",
    title: "《长夜微光》第七集反转播出，弹幕从质疑变成真香",
    summary: "前六集被吐槽节奏慢的观众连夜回来道歉，讨论帖一天涨了两千多层，口碑曲线堪称过山车。",
    category: "剧集",
    time: "12 分钟前",
    comments: "2,481",
    heat: "18.6万",
  },
  {
    id: "l2",
    title: "综艺新一期游戏环节太真实，嘉宾表情包直接出圈",
    summary: "本来只想随便看看，结果被那段反应笑到停不下来，评论区已经开始循环截图了。",
    category: "综艺",
    time: "38 分钟前",
    comments: "1,672",
    heat: "14.2万",
  },
  {
    id: "l3",
    title: "片方放出三分钟概念预告，美术风格直接拉满",
    summary: "没有一句台词，全靠画面和配乐撑住，很多人说这是今年最舍得的美术投入。",
    category: "预告",
    time: "1 小时前",
    comments: "1,209",
    heat: "11.7万",
  },
  {
    id: "l4",
    title: "老剧重制版的配色方案公开，修复前后对比太明显",
    summary: "从灰蒙蒙到通透有层次，技术帖被顶到首页，评论区开始催更播出时间。",
    category: "整活",
    time: "2 小时前",
    comments: "986",
    heat: "9.4万",
  },
  {
    id: "l5",
    title: "音乐节返场片段传开，主唱现场清唱高音稳到离谱",
    summary: "前排观众拍的原视频几乎没修音，评论区集体表示这才是现场该有的样子。",
    category: "现场",
    time: "3 小时前",
    comments: "842",
    heat: "8.1万",
  },
  {
    id: "l6",
    title: "动画剧场版最新海报发布，构图被网友夸有电影感",
    summary: "海报里的光影细节被逐帧放大分析，连带旧作也被翻出来重温。",
    category: "动画",
    time: "4 小时前",
    comments: "673",
    heat: "6.8万",
  },
];

export const feedHot: FeedItem[] = [
  {
    id: "h1",
    title: "年度讨论度最高的五个名场面，评论区吵了一整天",
    summary: "每个人心里的第一名都不一样，有人看剧情有人看演技，投票结果意外很贴近。",
    category: "盘点",
    time: "今天",
    comments: "5,120",
    heat: "42.3万",
  },
  {
    id: "h2",
    title: "被低估的宝藏剧集合集，刷完直呼相见恨晚",
    summary: "热度不高但口碑稳，很多人是刷完第一集就一口气看完了整季。",
    category: "片单",
    time: "昨天",
    comments: "3,864",
    heat: "35.7万",
  },
  {
    id: "h3",
    title: "那些被剪掉的名场面，看到花絮才知道错过了什么",
    summary: "正片里没出现的片段反而更上头，评论区疯狂求完整版。",
    category: "花絮",
    time: "昨天",
    comments: "3,209",
    heat: "29.6万",
  },
  {
    id: "h4",
    title: "一句话证明你看过这部剧，评论区全是名台词",
    summary: "没有剧透却句句戳中，新人看完全程懵圈，老粉笑而不语。",
    category: "互动",
    time: "2 天前",
    comments: "2,977",
    heat: "24.1万",
  },
  {
    id: "h5",
    title: "幕后团队访谈公开，原来这个镜头拍了整整三天",
    summary: "看完访谈再看正片，才发现每个细节都藏着功夫。",
    category: "访谈",
    time: "2 天前",
    comments: "2,145",
    heat: "19.8万",
  },
  {
    id: "h6",
    title: "今年的黑马作品盘点，开播前几乎没人看好",
    summary: "没有大制作没有强宣发，靠口碑一点点爬上来，越看越真香。",
    category: "盘点",
    time: "3 天前",
    comments: "1,886",
    heat: "16.3万",
  },
];

export const feedTalk: FeedItem[] = [
  {
    id: "t1",
    title: "到底该不该提前看剧透？评论区两派吵到不可开交",
    summary: "一派说影响体验，一派说知道结局才敢看，来聊聊你站哪边。",
    category: "讨论",
    time: "20 分钟前",
    comments: "6,304",
    heat: "38.4万",
  },
  {
    id: "t2",
    title: "如果只能推荐一部给朋友，你会选哪部？",
    summary: "楼下已经盖了几千层，几乎每部都被提名过一次。",
    category: "讨论",
    time: "1 小时前",
    comments: "4,712",
    heat: "31.2万",
  },
  {
    id: "t3",
    title: "结局是 HE 还是 BE，网友为这个吵了整整一周",
    summary: "开放式结局让两边都有话说，官方至今没有正面回应。",
    category: "话题",
    time: "3 小时前",
    comments: "3,998",
    heat: "27.5万",
  },
  {
    id: "t4",
    title: "选角争议再起，网友列出心目中的理想人选",
    summary: "从气质到声线逐条分析，评论区已经变成大型选角现场。",
    category: "讨论",
    time: "5 小时前",
    comments: "3,021",
    heat: "22.9万",
  },
  {
    id: "t5",
    title: "有哪些设定一开始觉得离谱，后来却真香了？",
    summary: "很多作品都是熬过前几集才封神，来说说你被劝退又回坑的经历。",
    category: "讨论",
    time: "8 小时前",
    comments: "2,540",
    heat: "18.7万",
  },
  {
    id: "t6",
    title: "配乐党集合：哪首歌让你为了它追完整部剧",
    summary: "好音乐真的能救一部剧，评论区已经变成歌单接龙。",
    category: "音乐",
    time: "10 小时前",
    comments: "2,108",
    heat: "15.4万",
  },
];

export const editorPicks: PickItem[] = [
  {
    id: "e1",
    title: "编辑部私藏片单：这五部冷门作品值得一个周末",
    summary: "热度不高但完成度惊人，从摄影到配乐都在水准线上，适合安安静静刷完。",
    category: "片单",
    readTime: "8 分钟读完",
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20still%20life%20of%20folded%20newspapers%20and%20a%20cup%20of%20tea%20on%20warm%20cream%20paper%20background%2C%20soft%20natural%20window%20light%2C%20muted%20amber%20and%20beige%20tones%2C%20calm%20magazine%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=560&seq=hl-editor-01&orientation=landscape",
  },
  {
    id: "e2",
    title: "从概念到成片：一部预告片是怎么被做出来的",
    summary: "拆解构图、节奏与配乐的选择逻辑，看完再回看预告会发现全是细节。",
    category: "幕后",
    readTime: "6 分钟读完",
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20beige%20paper%20texture%20with%20soft%20orange%20geometric%20shapes%20and%20subtle%20grain%2C%20editorial%20magazine%20cover%20art%20style%2C%20minimal%20balanced%20composition%2C%20calm%20mood%2C%20high%20detail&width=800&height=560&seq=hl-editor-02&orientation=landscape",
  },
  {
    id: "e3",
    title: "为什么大家越来越爱看「讨论」而不是「评价」",
    summary: "从评分到弹幕，观众更想找到能一起聊的人，而不是一个冷冰冰的分数。",
    category: "观察",
    readTime: "5 分钟读完",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20minimal%20reading%20corner%20with%20an%20open%20magazine%20and%20warm%20lamp%20glow%2C%20cream%20and%20soft%20amber%20tones%2C%20editorial%20photography%2C%20calm%20quiet%20atmosphere%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=560&seq=hl-editor-03&orientation=landscape",
  },
];

export const topics: TopicItem[] = [
  { name: "剧集讨论", count: "3,842" },
  { name: "综艺名场面", count: "2,915" },
  { name: "新片预告", count: "2,460" },
  { name: "幕后花絮", count: "1,988" },
  { name: "配乐OST", count: "1,504" },
  { name: "动画剧场", count: "1,276" },
  { name: "演技分析", count: "1,023" },
  { name: "选角争议", count: "876" },
  { name: "路透现场", count: "742" },
  { name: "冷门安利", count: "615" },
];

export const communityPosts: PostItem[] = [
  {
    id: "c1",
    user: "吃瓜不吐皮",
    initial: "瓜",
    tone: "bg-primary-100 text-primary-700",
    time: "6 分钟前",
    content:
      "刚看完新更新那集，弹幕从「弃了」刷到「真香」，这反转来得太突然了，有没有人一起聊聊第七集那个伏笔？",
    likes: 328,
    replies: "96 条回复",
    topic: "剧集讨论",
  },
  {
    id: "c2",
    user: "深夜刷剧党",
    initial: "夜",
    tone: "bg-accent-100 text-accent-700",
    time: "25 分钟前",
    content:
      "整理了一份本周更新的片单，按观看顺序排好了，评论区自取。免费看料就是要大家一起省时间。",
    likes: 512,
    replies: "143 条回复",
    topic: "片单安利",
  },
  {
    id: "c3",
    user: "只看花絮的人",
    initial: "花",
    tone: "bg-secondary-100 text-secondary-700",
    time: "1 小时前",
    content:
      "花絮比正片还好看系列。那个笑场镜头导演居然留下来了，反复看了五遍还是绷不住。",
    likes: 247,
    replies: "61 条回复",
    topic: "幕后花絮",
  },
  {
    id: "c4",
    user: "OST 收藏家",
    initial: "音",
    tone: "bg-primary-100 text-primary-700",
    time: "2 小时前",
    content:
      "片尾曲单曲循环一整天了。这种不刻意煽情的编曲真的很难得，有没有人知道作曲是谁？",
    likes: 189,
    replies: "42 条回复",
    topic: "配乐OST",
  },
];